import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import CButton from '@/components/shared/CButton';
import { MAP_STYLE_PRESETS } from '@/components/DesignStudio/MapStyleProperties/presets';

interface Props {
    id: number;
    item: string;
    readonly?: boolean;
    isDefault: boolean;
}

interface Emits {
    (event: 'edit', id: number): void;
    (event: 'remove', value: string): void;
    (event: 'set-default', value: number): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MapStyleListItem',
  props: {
    id: null,
    item: null,
    readonly: { type: Boolean },
    isDefault: { type: Boolean }
  },
  emits: ["edit", "remove", "set-default"],
  setup(__props: any) {

const props = __props as {
    id: number;
    item: string;
    readonly?: boolean;
    isDefault: boolean;
};




const mapStyle = computed(() => MAP_STYLE_PRESETS.find((preset) => preset.id === props.item));
const isEditable = computed(() => !MAP_STYLE_PRESETS.some((preset) => preset.id === props.item));
const itemLabel = computed(() => (mapStyle.value ? mapStyle.value.label : `Custom Style - ${props.item}`));

return { __sfc: true,props, mapStyle, isEditable, itemLabel, CButton }
}

})